const OTHER_ATTRIBUTES = {
    "broaderTransitive" : "",
    "narrowerTransitive" : "",
};

export default OTHER_ATTRIBUTES;